import { forwardRef, type Ref, type SVGProps } from "react";

function SvgFacility(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <path
        stroke="url(#facility_svg__a)"
        strokeWidth={10}
        d="M125 103V50.286a8 8 0 0 0-8-8h-8.889m0 0V103m0-60.714V26a8 8 0 0 0-8-8H73.889a8 8 0 0 0-8 8v16.286m0 60.714V42.286m0 0H57a8 8 0 0 0-8 8V103"
      />
      <path
        fill="#0D2B57"
        d="M29.975 2.975a.975.975 0 1 0-1.95 0c0 4.056-.895 6.754-2.595 8.455-1.7 1.7-4.399 2.595-8.455 2.595a.975.975 0 1 0 0 1.95c4.056 0 6.754.895 8.455 2.595 1.7 1.7 2.595 4.399 2.595 8.455a.975.975 0 1 0 1.95 0c0-4.056.895-6.754 2.595-8.455 1.7-1.7 4.399-2.595 8.455-2.595a.975.975 0 1 0 0-1.95c-4.056 0-6.754-.895-8.455-2.595-1.7-1.7-2.595-4.399-2.595-8.455"
      />
      <path stroke="#0C1C43" d="M96 102V90a4 4 0 0 0-4-4h-8a4 4 0 0 0-4 4v12" />
      <path stroke="#0C1C43" strokeLinecap="round" d="M38.5 103.5h99" />
      <defs>
        <linearGradient
          id="facility_svg__a"
          x1={87}
          x2={87}
          y1={18}
          y2={103}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgFacility);
export default ForwardRef;
